import { state } from './types';

export default {
  [state.CHANNELS]: [],
  [state.CHANNELS_BY_COLLECTION]: {},
  [state.USERS_BY_ID]: {},
  [state.MESSAGES]: [],
  [state.ACTIVE_CHANNEL]: null,
  [state.ACTIVE_COLLECTION_ID]: null,
  [state.POLLING_INTERVAL_ID]: null,
  [state.LAST_FETCHED_AT]: null,
  [state.FEED]: [],
  // Map of { [channelId]: ISO timestamp } tracking when the user last read each channel.
  // Populated from the server on full feed fetches; updated optimistically on mark-read.
  [state.CHANNEL_READ_AT]: {},
  [state.CHAT_PANEL_OPEN]: JSON.parse(
    localStorage.getItem('chatPanelOpen') || 'false'
  ),
  [state.CHAT_PANEL_WIDTH]: parseInt(
    localStorage.getItem('chatPanelWidth') || '380',
    10
  ),
  [state.ACTIVE_COLLECTION]: null,
  [state.COLLECTION_MEMBERS]: [],
  [state.NEW_CONVERSATION_MODE]: false,
  [state.SCROLL_TARGET_MESSAGE_ID]: null,
};
